import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=cb557294&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=cb557294&prod&lang=scss&scoped=true"
import style1 from "./UpdateNotification.vue?vue&type=style&index=1&id=cb557294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb557294",
  null
  
)

export default component.exports